<div class="flex items-center justify-between mt-3">
    <!-- Execution Time -->
    <div class="text-[10px] font-inter text-gray-400">
        Respondido em {{ executionTimeMs }}ms
    </div>

    <!-- Pagination -->
    <div *ngIf="showPagination && totalPages > 1" class="flex items-center gap-2">
        <span class="text-[11px] font-inter text-gray-500">
            {{ currentPage + 1 }} de {{ totalPages }}
        </span>
        <button
            (click)="onPreviousPage()"
            [disabled]="!canGoPrevious"
            class="p-1 rounded hover:bg-gray-200 disabled:opacity-30 disabled:cursor-not-allowed transition-colors">
            <mat-icon class="icon-size-4 text-gray-600">chevron_left</mat-icon>
        </button>
        <button
            (click)="onNextPage()"
            [disabled]="!canGoNext"
            class="p-1 rounded hover:bg-gray-200 disabled:opacity-30 disabled:cursor-not-allowed transition-colors">
            <mat-icon class="icon-size-4 text-gray-600">chevron_right</mat-icon>
        </button>
    </div>
</div>
